// extracted by mini-css-extract-plugin
module.exports = {"Product_Type_Dd":"ProductTypeAndProductFilters_Product_Type_Dd__3snTb","Product_Dd":"ProductTypeAndProductFilters_Product_Dd__2akTA"};